<template>
    <div>
        <template v-if="window_width >= 992">

            <b-btn size="sm" variant="outline-secondary" :to="reports_route">
                <font-awesome-icon :icon="'chart-line'" />
                {{ $t('reports.reports') }}
            </b-btn>
        </template>

        <template v-else>
            <b-link class="plus-header-accordion-links" :to="reports_route" active-class="active"><font-awesome-icon :icon="'chart-line'" />
                {{ $t('reports.reports') }}
            </b-link>
        </template>
    </div>

</template>
<script>

export default {
    mounted() {
        this.$nextTick(() => {
              window.addEventListener('resize', this.onResize);
        })
    },

    beforeDestroy() { 
            window.removeEventListener('resize', this.onResize); 
    },

    data: function () {
        return {
            window_width: window.innerWidth,
            reports_route: '/reports',
        }
    },

    methods: {
        onResize() {
            this.window_width = window.innerWidth;
        },  
    },


}

</script>